<template>
  <div class="check">
    <h2>任务单审核</h2>
    <div class="list-title">
      <span>任务名称：{{params.task_title}}</span>
      <span>公司名称:{{params.company_name == null || params.company_name == ''? '暂无' : params.company_name }}</span><!-- v-if="params.company_name" -->
    </div>
    <!-- tab表头 -->
    <el-tabs v-model="PageConfig.searchList.status" @tab-click="changeTab">
      <el-tab-pane label="待审核" name="1"></el-tab-pane>
      <el-tab-pane label="完成" name="2"></el-tab-pane>
      <el-tab-pane label="驳回" name="3"></el-tab-pane>
    </el-tabs>
    <!-- 筛选 -->
    <el-row :gutter="20" style="margin-bottom: 35px">
      <el-col :span="24">
        <el-button type="primary" style="margin-right: 10px;" v-if="PageConfig.searchList.status == 1" @click="allPass">批量通过</el-button>
        <el-input style="width: 150px;" placeholder="请输入用户ID" v-model="PageConfig.searchList.uid" ></el-input><el-button style="margin-left: 10px;" type="primary" @click="getSearch">搜索</el-button>
      </el-col>
    </el-row>
    <Table ref="multipleTable" :tableHeader="dymicHeader" :tableData="dataList" :previewList="previewList" :config="PageConfig" @pagechange="getList($event)" @getcheck="getcheck">
      <template v-slot:handles="params">
        <el-button  type="primary" size="mini" @click="handlePass([params.row.id])">通过</el-button>
        <el-button type="danger" size="mini" @click="handleRefuse(params.row)">拒绝</el-button>
      </template>
    </Table>
  </div>
</template>

<script>
import "@/shared/plugins/element";
import Table from '../publishComponents/table.vue'
import { tableHeader } from './const.js'
import Api from "@/api";
export default {
  name:'post-money-task',
  components:{
    Table
  },
  data() {
    return {
      dymicHeader:[],//动态表头
      params: {},
      PageConfig:{
        pageArray:[10,20,50,100],
        total:0,
        searchList:{
          status:'1',
          uid:'',
        	page: 1,
        	pageSize: 10,
          taskid:''
        }
      },
      dataList: [],
      multipleSelection: [],//多选
      previewList:[],//预览图片处理
      checkList:[],
    };
  },
  beforeCreate() {
    // this.form = this.$form.createForm(this, { name: "dynamic_form_item" });
    // this.form.getFieldDecorator("keys", { initialValue: [], preserve: true });
  },
  created() {
    this.params = this.$route.query;
    this.PageConfig.searchList.taskid = this.$route.query.id;
    //selection 多选框字段  handle 操作栏字段
    let field =['selection','user_id','user_post_text','user_post_images','commit_at','verify_left_time','handle'];
    this.dymicHeader = this.filterHeader(field);
    let params = this.PageConfig.searchList;
    this.requestList(params);
  },
  methods: {
    //搜索
    getSearch(){
      this.requestList(this.PageConfig.searchList);
    },
    /**
     * 切换表头
     */
    changeTab(e) {
      this.PageConfig.searchList.status = e.name;
      let field = [];
      //selection 多选框字段  handle 操作栏字段
      if(e.name == '1'){
        field = ['selection','user_id','user_post_text','user_post_images','commit_at','verify_left_time','handle'];
      }else if(e.name == '2'){
        field = ['selection','user_id','user_post_text','user_post_images','price','commit_at','verify_at'];
      }else{
        field = ['selection','user_id','user_post_text','user_post_images','commit_at','verify_at','reject_reason'];
      }
      this.dymicHeader = this.filterHeader(field);
      //只有状态值为2时显示多选框
      e.name == '1' ? tableHeader[0].show = true : tableHeader[0].show = false;
      let params = this.PageConfig.searchList;
      this.requestList(params);
    },
    //过滤每个tab需要的字段值
    filterHeader(field){
      let newArr = [];
      tableHeader.forEach(item => {
        if (field.includes(item.showFiled)) {
            newArr.push(item);
        };
      })
      return newArr
    },
    async requestList(params){
      try{
        let res = await Api.post.getTaskPostList(params);
        res.list.forEach((item,index) =>{
          if(item.user_post_images == null){
            item.user_post_images = []
          }
          if(item.user_post_text == null){
            item.user_post_text = []
          }
        })
        this.PageConfig.total = res.total;
        this.dataList = res.list;
      }catch(e){
        //TODO handle the exception
      }
    },
    //多选
    getcheck(val){
      let temp = [];
      val.forEach((item,index)=>{
        temp.push(item.id)
      })
      this.multipleSelection = val;
      this.checkList = [...temp]
      console.log(this.multipleSelection);
    },
    //分页加载数据
    getList(val){
      let params = this.PageConfig.searchList;
      params = {...val,status:params.status,user_id:params.user_id,taskid:params.taskid}
      this.requestList(params);
    },
    //批量通过
    allPass(){
      if(this.checkList.length > 0){
        this.handlePass(this.checkList)
      }else{
        this.$message.error("请先选择任务单！");
      }
    },
    //通过
    handlePass(row){
      this.$confirm('确认审核通过吗？?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          ids:row,
          result:10,
          reason:''
        }
        try{
          let res = await Api.post.postTaskReview(params);
          console.log(res)
          this.$message.success("审核通过！");
          this.$refs.multipleTable.clearCheck();
          this.checkList = [];
          this.requestList(this.PageConfig.searchList);
        }catch(e){
          //TODO handle the exception
          this.$refs.multipleTable.clearCheck();
          this.checkList = [];
        }
      }).catch(() => {
                 
      });
    },
    //拒绝
    handleRefuse(row){
      this.$prompt('请填写拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType:'textarea',
        inputPattern:/\S/,
        inputErrorMessage: '拒绝原因未填写',
        inputPlaceholder:'请输入拒绝原因'
      }).then(async ({ value }) => {
        let params = {
          ids:[row.id],
          result:20,
          reason:value
        }
        try{
          let res = await Api.post.postTaskReview(params);
          this.$message.success("操作成功！");
          this.requestList(this.PageConfig.searchList);
        }catch(e){
          //TODO handle the exception
        }
      }).catch(() => {
           
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.check {
  h2 {
    font-weight: 800;
  }
  .list-title {
    margin: 20px 0;
    span:first-child {
      margin-right: 60px;
    }
  }
}
</style>